import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  return <Section dark data-id="element-184">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-185">
        {/* FOR */}
        <div className="bg-navy-light p-8 md:p-10 rounded-sm border-t-4 border-gold" data-id="element-186">
          <h3 className="text-2xl font-serif text-cream mb-8" data-id="element-187">
            Este protocolo ES para:
          </h3>
          <ul className="space-y-6" data-id="element-188">
            {['Mujeres profesionales, coaches y emprendedoras de más de 45 años.', 'Mujeres que valoran la elegancia, la discreción y la autoridad.', 'Expertas que quieren monetizar su conocimiento en TikTok sin perder su esencia.', 'Aquellas que están cansadas de sentirse ignoradas por el mundo digital.'].map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-189">
                <Check className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-190" />
                <span className="text-cream-dark font-light" data-id="element-191">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* NOT FOR */}
        <div className="bg-navy-light p-8 md:p-10 rounded-sm border-t-4 border-charcoal-light" data-id="element-192">
          <h3 className="text-2xl font-serif text-cream/70 mb-8" data-id="element-193">
            Este protocolo NO ES para:
          </h3>
          <ul className="space-y-6" data-id="element-194">
            {['Personas que buscan fama rápida a través de la comedia o el baile.', 'Quienes no están dispuestas a invertir tiempo en mejorar su calidad visual.', 'Gente que prefiere cantidad de seguidores sobre calidad de clientes.'].map((item, i) => <li key={i} className="flex items-start space-x-4 opacity-70" data-id="element-195">
                <X className="w-5 h-5 text-red-400/60 shrink-0 mt-1" data-id="element-196" />
                <span className="text-cream-dark font-light" data-id="element-197">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}